import { fromConst, fromNestedArguments } from './base';
export function boolConst(rawData, tokenOptions) {
  return fromConst(a => a, rawData, tokenOptions);
}
export function boolTokenFromNestedArguments(rawData, argList, tokenOptions) {
  return fromNestedArguments(a => a, rawData, argList, tokenOptions);
}
//# sourceMappingURL=bools.js.map